import { buildDeserializer, SerializeMap } from "lib/serializerUtils";

// Per-type field maps matching backend's actual serialized shapes
const createdActivityMap = {
  id: "id",
  date: "date",
  invoiceNumber: "invoice_number",
};

const paymentActivityMap = {
  date: "date",
  totalAmountCents: "total_amount_cents",
  invoiceNumber: "invoice_number",
};

const retainedProceedsActivityMap = {
  date: "date",
  invoiceNumber: "invoice_number",
};

const reversalActivityMap = {
  date: "date",
  invoiceNumber: "invoice_number",
};

const interestActivityMap = {
  date: "date",
  note: "note",
};

const modifiedActivityMap = {
  date: "date",
  historyChangeReason: "history_change_reason",
};

const activitySerializeMap = {
  created: createdActivityMap,
  payments: paymentActivityMap,
  creditNotes: paymentActivityMap,
  retainedProceeds: retainedProceedsActivityMap,
  reversal: reversalActivityMap,
  interest: interestActivityMap,
  modified: modifiedActivityMap,
};

interface BillingDocumentActivityResponse {
  id: string;
  activity: typeof activitySerializeMap;
}

const serializeMap: SerializeMap<BillingDocumentActivityResponse> = {
  id: "id",
  activity: activitySerializeMap,
};

const nestedObjectMap = {
  retained_proceeds: "retainedProceeds",
  credit_notes: "creditNotes",
};

export const deserializeBillingDocumentActivity = buildDeserializer<BillingDocumentActivityResponse>(
  serializeMap,
  "billingDocumentActivity",
  nestedObjectMap,
);
